import type {
  GatorProtectThreatFileApi,
  GatorProtectThreatsListPageApi,
  GatorProtectThreatsListResponseApi,
} from './api.types';
import type {
  GatorProtectThreatFile,
  GatorProtectThreatsListPage,
  GatorProtectThreatsListResponse,
} from './model';

export interface ThreatsListMapper {
  fromApi(_api: GatorProtectThreatsListResponseApi): GatorProtectThreatsListResponse;
}

export interface ThreatsListRepository {
  fetchPage(_page: number): Promise<GatorProtectThreatsListResponseApi>;
}

function mapThreatFileFromApi(row: GatorProtectThreatFileApi): GatorProtectThreatFile {
  return {
    name: row.name,
    path: row.path,
    category: row.category,
    status: row.status,
    detectedAt: row.detected_at,
    remediatedAt: row.remediated_at,
  };
}

function mapThreatsPageFromApi(page: GatorProtectThreatsListPageApi): GatorProtectThreatsListPage {
  return {
    currentPage: page.current_page,
    perPage: page.per_page,
    total: page.total,
    lastPage: page.last_page,
  };
}

export function mapThreatsListResponseFromApi(api: GatorProtectThreatsListResponseApi): GatorProtectThreatsListResponse {
  return {
    success: api.success,
    httpStatusCode: api.http_status_code,
    internalCode: api.internal_code,
    data: {
      files: api.data.files.map(mapThreatFileFromApi),
      page: mapThreatsPageFromApi(api.data.page),
    },
    notifications: api.notifications,
  };
}

export const threatsListMapper: ThreatsListMapper = {
  fromApi: mapThreatsListResponseFromApi,
};
